export default {
    init() {

        jQuery( ".breadcrumbs .nextNode" ).click(function() {
            jQuery( "#sidepages li.active" ).next().trigger( "click" );
            
            jQuery([document.documentElement, document.body]).animate({
                scrollTop: jQuery("#sidepages li.active").offset().top - 200
            }, 2000);
        });

        jQuery( "#sidepages li" ).click(function() {
            let id = jQuery(this).data('id');

            jQuery('#sidepages li').each(function () { 
                jQuery(this).removeClass("active");
            });
            
            if (id === undefined)
            {
                return;
            }

            jQuery(".breadcrumbs #currentNode").text(jQuery(this).text());
            
            jQuery(this).addClass("active");
            
            let next = jQuery("#sidepages li.active").next();

            if (next.length)
            {
                jQuery(".breadcrumbs .nextNode").show();

                jQuery(".breadcrumbs .nextNode").text(next.text());
    
            }
           
            let content = jQuery(`.pagecontent[data-id='${id}']`);

            if (!content)
            {
                return;
            }

            if (content.hasClass("active"))
            {
                return;
            }


            jQuery('.pagecontent').each(function () { 
                jQuery(this).removeClass("active");
            });

            content.addClass("active");

     
            if (!next.length)
            {
                jQuery(".breadcrumbs .nextNode").hide();
            }

        });

        let windowsize = $(window).width();

        let nodeActive = jQuery("#sidepages li.active");

        if (!nodeActive.length)
        {
            
            return;
        }

        jQuery(".breadcrumbs #currentNode").text(nodeActive.text());

        let next = jQuery("#sidepages li.active").next();

        if (!next.length)
        {
            jQuery(".breadcrumbs .nextNode").hide();
        } else {
            jQuery(".breadcrumbs .nextNode").show();
        }
        
        if (next.length)
        {
            jQuery(".breadcrumbs .nextNode").text(next.text());
        }


    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/templatesidebar.js